// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"link-unlink"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.26634 11.7832L4.92942 14.1201C3.56259 15.4869 3.56259 17.703 4.92942 19.0698C6.29626 20.4367 8.51233 20.4367 9.87917 19.0698L12.2161 16.7329M11.7851 7.2639L14.122 4.92698C15.4889 3.56015 17.7049 3.56015 19.0718 4.92698C20.4386 6.29382 20.4386 8.50989 19.0718 9.87673L16.7349 12.2136","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2.34668 9.08984H4.84668M4.30371 4.30469L6.42503 6.42601M9.25293 4.68164V2.18164M19.6946 19.6946L17.5732 17.5732M19.3154 14.7461L21.8154 14.7461M14.9092 21.6523V19.1523","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LinkUnlinkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'link-unlink',
    ref,
    icon: element,
  },
));

LinkUnlinkIcon.displayName = 'LinkUnlinkIcon';

export default LinkUnlinkIcon;
